export enum TransactionExecutionStep {
  EXECUTE,
  SIMULATE, // gas estimation
  PREPARE_RELAYER_REQUEST, // just Enzyme gas relayer
  USER_SIGN,
  REQUEST_TX_FROM_RELAYER, // just Enzyme gas relayer
  BROADCAST,
  PROCESS,
  SUCCESS,
  SUCCESS_PARTLY,
  ERROR,
}
